import React from 'react';
import PropTypes from 'prop-types';
import '../styles/card.css';


const Card = (props) => {
  return (
    <div className={`card-blog-post-card ${props.rootClassName} `}>
      <img alt={props.imageAlt} src={props.imageSrc} className="card-image" />
      <div className="card-container">
        <span className="card-text">{props.label}</span>
        <span className="card-text1">{props.title}</span>
        <span className="card-text2">{props.description}</span>
        <div className="card-container1">
          <div className="card-profile">
            {/* Map through the icon array and render the corresponding SVG icons */}
            {props.icons.map((icon) => (
              <div className="card-image1" >{icon} </div>
            ))}
            
          </div>
          <a className="about-button1 button" href={props.url} target="_blank" rel="noopener noreferrer">
            <span>
              <span>View Project</span>
              <br />
            </span>
          </a>
        </div>
      </div>
    </div>
  );
};

Card.defaultProps = {
  iconAlt: 'icon',
  label: 'ENTERPRISE',
  title: 'Lorem ipsum dolor sit amet',
  rootClassName: '',
  imageAlt: 'image',
  description:
    'Lorem ipsum dolor sit amet, consectetur, adipiscing elit. Sed non volutpat turpis.  ​ Mauris luctus rutrum mi ut rhoncus. Integer in dignissim tortor. Lorem  ​​ ipsum dolor sit amet, consectetur adipiscing elit.',
  imageSrc:
    'https://images.unsplash.com/photo-1547841243-eacb14453cd9?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIyfHxjaXR5fGVufDB8fHx8MTYyNjE4NjYxMg&ixlib=rb-1.2.1&w=1000',
  author: 'Jon Doe',
  time: '5 min read',
};

Card.propTypes = {
  iconAlt: PropTypes.string,
  label: PropTypes.string,
  title: PropTypes.string,
  rootClassName: PropTypes.string,
  imageAlt: PropTypes.string,
  description: PropTypes.string,
  imageSrc: PropTypes.string,
  url: PropTypes.string,
  icons: PropTypes.arrayOf(PropTypes.elementType), // Expecting an array of React components for SVG icons
};

export default Card;
